module.exports = __webpack_public_path__ + "static/img/password.0521aba3.png";